<script lang="ts"></script>

<style lang="scss">
    th {
        --width: var(--width-raider-io);

        text-align: center;
        vertical-align: bottom;
    }
</style>

<th>Score</th>
